import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './Comparison.css';
import cs from '../../commonStyle.css';
import messages from '../../../locale/messages';

class Comparison extends React.Component {
  render() {
    const motoStream = [
      messages.newLandingComparisonMotoItem1,
      messages.newLandingComparisonMotoItem2,
      messages.newLandingComparisonMotoItem3,
      messages.newLandingComparisonMotoItem4,
      messages.newLandingComparisonMotoItem5,
      messages.newLandingComparisonMotoItem6,
      messages.newLandingComparisonMotoItem7,
    ];

    const agencies = [
      messages.newLandingComparisonAgencyItem1,
      messages.newLandingComparisonAgencyItem2,
      messages.newLandingComparisonAgencyItem3,
      messages.newLandingComparisonAgencyItem4,
      messages.newLandingComparisonAgencyItem5,
      messages.newLandingComparisonAgencyItem6,
      messages.newLandingComparisonAgencyItem7,
    ];

    return (
      <section className={s.comparisonSection}>
        <h2><FormattedMessage {...messages.newLandingComparisonTitle} /></h2>
        <div className={s.comparisonGrid}>
          <div className={s.compareCol}>
            <h3><FormattedMessage {...messages.newLandingComparisonMotoLabel} /></h3>
            <ul>
              {motoStream.map((item, index) => (
                <li key={`ms-${index}`}>
                  <svg className={cx(s.compareIcon, s.iconCheck)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  <FormattedMessage {...item} />
                </li>
              ))}
            </ul>
          </div>
          <div className={s.compareCol}>
            <h3><FormattedMessage {...messages.newLandingComparisonAgencyLabel} /></h3>
            <ul>
              {agencies.map((item, index) => (
                <li key={`agency-${index}`}>
                  <svg className={cx(s.compareIcon, s.iconCross)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  <FormattedMessage {...item} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default withStyles(s, cs)(Comparison);
